module.exports = __webpack_public_path__ + "media/images/bigboxicon-ccc89f89.svg";